import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["form", "success", "error", "pending"]
  }

  static get values() {
    return {
      exportType: String,
      paramData: Object
    }
  }

  async exportCsv(event) {
    event.preventDefault()

    this.showPending()

    try {
      const response = await fetch(
        `/controlpanel/csv_exports/${this.exportTypeValue}_csv_exports`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": this.csrfToken
          },
          body: JSON.stringify({
            csv_export: { param_data: this.paramDataValue }
          })
        }
      )

      if (response.ok) {
        this.showSuccess()
      } else {
        this.showError()
      }
    } catch (error) {
      this.showError()
    }
  }

  showPending() {
    this.formTarget.hidden = true
    this.pendingTarget.hidden = false
  }

  showSuccess() {
    this.pendingTarget.hidden = true
    this.successTarget.hidden = false
  }

  showError() {
    this.pendingTarget.hidden = true
    this.errorTarget.hidden = false
  }

  get csrfToken() {
    const csrfMetaTag = document.querySelector("meta[name='csrf-token']")

    return csrfMetaTag ? csrfMetaTag.content : ""
  }
}
